const user_endpoint = {
    nameList: 'user/name-list',
    user: 'user',
    currentUserDetail: 'user/current-user-detail',
    changeUserStatus: 'user/status',
    permissionList: 'user/permission-list',
    
}

export default user_endpoint;